// Tijdstippen in de Helpdesk: altijd Belgische tijd (Europe/Brussels).
//
// Het bronsysteem levert zijn datums ZONDER tijdzone ("2026-08-03T09:40:53.209200")
// en bedoelt daarmee UTC. `new Date()` leest zo'n tekst als LOKALE tijd van de
// browser: in België stond elk ticket daardoor 1 uur (winter) of 2 uur (zomer) te
// vroeg op het scherm, en de wachttijd-kengetallen telden evenveel te veel. De
// eigen tijdstippen van het portaal (logboek, sluitmoment) komen wél met een "Z".
//
// Twee regels dus, op één plek:
//   1. een tijdstip zonder zone-aanduiding is UTC (`hdTijdMs`);
//   2. tonen gebeurt altijd in Europe/Brussels, ongeacht waar de browser staat
//      (`hdFmtBrussel`) — Intl kent de zomer-/wintertijd, wij rekenen niets zelf.
// Backend-tegenhanger: backend/src/util/helpdeskDatum.js.

export const HD_TIJDZONE = 'Europe/Brussels';

const HEEFT_ZONE = /(?:[zZ]|[+-]\d{2}:?\d{2})$/;
const DATUM_TIJD = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/;

// Tijdstip → milliseconden sinds epoch (NaN als het geen tijdstip is).
export function hdTijdMs(v) {
  if (v == null || v === '') return NaN;
  if (v instanceof Date) return v.getTime();
  if (typeof v === 'number') return v;
  let s = String(v).trim();
  if (DATUM_TIJD.test(s)) {
    s = s.replace(' ', 'T');
    // Microseconden → milliseconden: niet elke browser leest zes decimalen.
    s = s.replace(/(\.\d{3})\d+/, '$1');
    if (!HEEFT_ZONE.test(s)) s += 'Z';
  }
  return Date.parse(s);
}

let formatter = null;
const fmt = () => {
  if (!formatter) {
    formatter = new Intl.DateTimeFormat('nl-BE', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false, timeZone: HD_TIJDZONE,
    });
  }
  return formatter;
};

// Enkel het uur ("14:32"), voor "bijgewerkt om …" naast de verversknop.
let uurFormatter = null;
export function hdUurBrussel(v) {
  const ms = hdTijdMs(v);
  if (!Number.isFinite(ms)) return '';
  if (!uurFormatter) uurFormatter = new Intl.DateTimeFormat('nl-BE', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: HD_TIJDZONE });
  return uurFormatter.format(new Date(ms));
}

// Twee lijstrecords inhoudelijk gelijk? `open_seconds` rekent de server bij elke
// lezing opnieuw uit en telt dus niet als wijziging.
const zonderKlok = (t) => { const rest = { ...(t || {}) }; delete rest.open_seconds; return JSON.stringify(rest); };

// Voeg de gewijzigde tickets (GET /wijzigingen) in de geladen lijst in: bestaande
// op hun plaats vervangen, nieuwe vooraan. Geeft DEZELFDE array terug als er niets
// echt wijzigde, zodat React niets hertekent en geen kengetal herrekent.
export function hdVoegWijzigingenIn(lijst, gewijzigd) {
  if (!Array.isArray(gewijzigd) || gewijzigd.length === 0) return lijst;
  const nieuwPerId = new Map(gewijzigd.map((t) => [t.id, t]));
  let anders = false;
  const uit = (lijst || []).map((t) => {
    const n = nieuwPerId.get(t.id);
    if (!n) return t;
    nieuwPerId.delete(t.id);
    if (zonderKlok(n) === zonderKlok(t)) return t;
    anders = true;
    return n;
  });
  if (nieuwPerId.size) { anders = true; uit.unshift(...nieuwPerId.values()); }
  return anders ? uit : lijst;
}

// "03/08/2026 11:40" in Belgische tijd; '—' zonder waarde, de ruwe tekst als het
// geen tijdstip blijkt.
export function hdFmtBrussel(v) {
  if (v == null || v === '') return '—';
  const ms = hdTijdMs(v);
  if (!Number.isFinite(ms)) return String(v);
  try { return fmt().format(new Date(ms)).replace(',', ''); } catch { return String(v); }
}
